<template>
  <div class="overlay">
    <c-spinner />
  </div>
</template>

<script>
import CSpinner from './CSpinner'
/**
 * Оверлей с индикатором загрузки. Контейнер, для которого используется компонент, должен иметь класс overlay-wrapper.
 */
export default {
  name: 'CLoadingOverlay',
  components: { CSpinner }
}
</script>
